import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { List, ListItem, Text, Left, Right, Icon } from 'native-base';
import TeleOnlineIcon from './icons/TeleOnlineIcon';
import { styles } from '../constants';
import { Platform } from 'react-native';

class BlockList extends Component {
  handlerChange = (element) => {
    const { block, onChange } = this.props;

    onChange && onChange({
      block,
      element
    });
  }

  render() {
    const { block } = this.props;

    let rzdShitfix = block.name === "24=>860000588" && Platform.OS === "web"; // только для определённого блока и только на вебе добавляем svg иконку

    return (
      <List>
        {block.elements.map((element, i) => {

          let hasActionOpenUrl = element.action && element.action.type && element.action.type === "openUrl";

          let itemStyle = hasActionOpenUrl ? styles.linkText : styles.normalText;
          itemStyle = rzdShitfix ? styles.linkBold : itemStyle;

          return <ListItem
            style={{
              paddingLeft: 0,
              paddingRight: 0
            }}
            noIndent
            key={i}
            onPress={() => this.handlerChange(element)}
          >
            <Left>
              <Text style={itemStyle}>{element.label}</Text>
            </Left>
            {element.value && !rzdShitfix ? <Right>
              <Icon name="arrow-forward" />
            </Right> : null}
            {!element.value && rzdShitfix ? <Right>
              <TeleOnlineIcon height="24" width="24" />
            </Right> : null}
          </ListItem>;
        }
        )}
      </List>
    );
  }
}

BlockList.propTypes = {
  block: PropTypes.object,
  onChange: PropTypes.func
};

export default BlockList;